<template>
    <div class="accoundRecord">
        <Header title="账户记录" :show-back="true"/>
        <div class="container">
            <div class="filter">
                <div class="filter-type">
                    <dl @click="showSelectClick">{{businessType ? businessType : '业务类型'}}</dl>
                    <dl @click="showCoin=true">货币类型</dl>
                </div>
                <div class="search-type">
                    <img src="../../assets/img/icon/search.png"/>
                </div>
            </div>
            <van-list
                    v-model="loading"
                    :finished="finished"
                    :offset="10"
                    finished-text="没有更多了"
                    @load="onLoad">
                <van-cell
                        v-for="(item,index) in recordData" :key="index"
                        :title="item.text"
                        :label="formatDate(item.create_time,2)"
                        :value="`${parseFloat(item.number)} ${item.coin.toLocaleUpperCase()}`"
                        class="cell"
                        title-class="cell-title"
                        label-class="cell-label"
                        value-class="cell-value"/>
            </van-list>
        </div>
        <van-action-sheet
                v-model="showBusiness"
                :actions="businessTypeList"
                cancel-text="取消"
                @select="onSelect"
                @cancel="onCancelSelect"
                :round="false"/>
        <van-action-sheet
                v-model="showCoin"
                :actions="coinList"
                cancel-text="取消"
                @select="chooseCoin"
                @cancel="cancelCoin"
                :round="false"/>
    </div>
</template>

<script>
    import Header from "../../components/header";

    export default {
        components: {
            Header
        },
        data() {
            return {
                recordData: [],
                page: 0,
                total: null,
                loading: false,
                finished: false,
                showBusiness: false,
                businessTypeList: [],
                businessType: '',
                showCoin: false,
                coinList: [
                    {
                        name: "USDT",
                    },
                    {
                        name: "XMI",
                    }
                ],
                coin: ""
            };
        },
        methods: {
            getData() {
                this.page++;
                this.ajax.post("appapi/user/getLog", {page: this.page, coin: this.coin}).then(res => {
                    if (res.data.code === 1) {
                        this.recordData.push(...res.data.data.data);
                        this.total = res.data.data.total;
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        if (this.recordData.length >= this.total) {
                            console.log("加载完成");
                            this.finished = true;
                        }
                    }
                });
            },
            getFormType() {
                this.ajax.get('appapi/log/from_type').then((res) => {
                    if (res.data.code === 1) {
                        this.businessTypeList = res.data.data
                    }
                })
            },
            onSelect(item) {
                this.businessType = item.name;
                this.showBusiness = false
            },
            onCancelSelect() {
                this.showBusiness = false
            },
            showSelectClick() {
                this.showBusiness = true
            },
            onLoad() {
                setTimeout(() => {
                    this.getData();
                    this.getFormType()
                }, 500);
            },
            chooseCoin(item) {
                this.coin = item.name.toLocaleLowerCase();
                this.showCoin = false;
                this.getData();
            },
            cancelCoin() {
                this.showCoin = false
            }
        }
    }

</script>

<style lang="scss">
    .accoundRecord {
        .container {
            padding: 40px 30px;

        }

        .filter {
            @include flex($main: space-between, $cross: center);
            padding: 0 30px;
            background: #f4f4f4;

            &-type {
                color: #999;
                font-size: 24px;
                @include flex();
                height: 70px;

                dl {
                    cursor: pointer;
                    position: relative;
                    margin-right: 90px;
                    height: 100%;
                    line-height: 70px;

                    &:after {
                        position: absolute;
                        width: 0;
                        height: 0;
                        border-top: 10px solid #DBDBDB;
                        border-left: 10px solid transparent;
                        border-right: 10px solid transparent;
                        right: -37px;
                        top: 50%;
                        transform: translateY(-50%);
                        content: '';

                    }
                }
            }

            .search-type {
                width: 42px;
                height: 42px;
            }
        }

        .cell {
            padding: 30px;
            font-size: 24px;
            font-weight: bold;
            line-height: 20px;
            color: #3E3E3E;

            &-value {
                color: #3E3E3E;
                font-size: 30px;
                line-height: 60px;
            }

            &-label {
                font-size: 22px;
                color: #999;
                font-weight: normal;

            }

        }
    }
</style>
